export default "__VITE_ASSET__BR$8PKk9__"